module.exports = new __parcel__URL__("ErrorIcon.12961569.svg").toString();